import apiEndpoints from "@/services/apiEndpoints";
export default {
  data() {
    return {
      selectedDepartmentOptions: [],
      optionDepartmentList: []
    };
  },
  created() {
    this.getOptionsDepartment();
  },
  methods: {
    onChangeDepartment() {
      let ids = this.selectedDepartmentOptions?.map(item => item.id) ?? []
      this.filters.department = ids;
      this.getData();
    },
    checkDepartmentChecked(option) {
      return this.selectedDepartmentOptions.some(item => item.id == option.id);
    },
    checkDepartmentCheckedAll() {
      return (
        this.selectedDepartmentOptions.length ==
        this.optionDepartment[0].attributes.length
      );
    },
    async getOptionsDepartment() {
      const response = await this.$http.get(apiEndpoints.department_list_options, {
        ...this.filters,
      });
      const { status, data } = response;
      if (status) {
        this.optionDepartmentList = data.result;
      }
    }
    },
  computed: {
    
     optionDepartment() {
      
      let options = [
        {
          selectAll: "すべて",
          attributes:
            this.optionDepartmentList ??
            []
        }
      ];
      return options;
    }
  }
};
